'use strict';

var KHOROS = {
    sliders: {
        init: function() {
            this.setUpEvents();
            this.autoRotate();
        },
        setUpEvents: function() {
            var that = this;

            $('body').on('click', '[data-slider-toggle]', function(){
                that.showSlide($(this).data('slider-toggle'));
            });
        },
        showSlide: function(sliderDataSelector) {
            var $slide = $('[data-slider-slide='+ sliderDataSelector + ']');
            var $slider = $slide.closest('[data-slider]');
            var $toggle = $slider.find('[data-slider-toggle=' + sliderDataSelector + ']');
            var $mobileSelector = $slider.find('.mobileSelector__label');

            //activate clicked toggle
            $slider.find('[data-slider-toggle]').removeClass('active');
            $toggle.addClass('active');

            //show selected slide
            $slider.find('[data-slider-slide]').each(function(){
                var $slide = $(this);

                if ($slide.data('slider-slide') == sliderDataSelector) {
                    $slide.addClass('active');

                    //animate images
                    $slide.find('img').each(function(){
                        $(this).addClass($(this).data('animation'));
                    });
                }
                else {
                    $slide.removeClass('active');
                }
            });

            //update mobile selector text
            $mobileSelector.text($toggle.eq(0).text());
        },
        normalizeSlideHeights: function() {
            $('[data-slider]').each(function(){
                var baseHeight = 0;

                $(this).find('.slide').each(function(){
                    if ($(this).outerHeight() > baseHeight) {
                       baseHeight = $(this).outerHeight();
                    }
                });

                $(this).find('.slide').css({height: baseHeight + 'px'});
            });
        },
        resetSlideHeights: function() {
            $('[data-slider] .slide').css({height: 'auto'});
        },
        autoRotate: function() {
            var $sliders = $('[data-slider]');
            var that = this;

            $sliders.each(function(){
                var $slider = $(this);
                var autoRotate = true;
                var $toggles = $slider.find('.slider__toggles li');

                var slideCount = $toggles.length;
                var secondsToNextClick = 6;
                var rotationInterval = false;

                var startAutoRotate = function(){
                    rotationInterval = setInterval(function(){
                        if (autoRotate) {
                            // find next slide index
                            var nextSlideIndex = 0;

                            $toggles.each(function(index){
                                var $toggle = $(this);

                                if($toggle.find('[data-slider-toggle]').hasClass('active')) {
                                    nextSlideIndex = index + 1;
                                    return false;
                                }
                            });

                            if (nextSlideIndex >= slideCount) {
                                nextSlideIndex = 0;
                            }

                            // click next slide
                            var $nextSlideToggle = $toggles.eq(nextSlideIndex).find('[data-slider-toggle]');
                            that.showSlide($nextSlideToggle.data('slider-toggle'));
                        }

                    }, secondsToNextClick * 1000);
                };

                $slider.on('mouseenter', function(){
                    autoRotate = false;
                });
                $slider.on('mouseleave', function(){
                    autoRotate = true;
                });
                $slider.on('click', function(){
                    autoRotate = false;
                    rotationInterval = false;
                });

                startAutoRotate();
            });
        }
    },
    elementToggles: {
        init: function() {
            this.setUpEvents();
        },
        setUpEvents: function() {
            $('body').on('click', '[data-toggle]', function(){
                $($(this).data('toggle')).toggle();

                //custom events
                var targetSelector = $(this).data('toggle');

                if (targetSelector == '#globalSearchForm') {
                    $('#globalSearchForm input').focus();
                }
            });
        }
    },
    mobileMenu: {
        init: function() {
            this.setUpEvents();
        },
        setUpEvents: function() {
            $('body').on('click', '[data-mobile-menu-toggle]', function(){
                $(this).closest('li').toggleClass('active');
            });
        }
    },
    animations: {
        isElementInViewport: function(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();

            var verticalOffset = 0;
            var elemTop = $(elem).offset().top - verticalOffset;
            var elemBottom = elemTop + $(elem).outerHeight();

            var isVisible = ((elemBottom > docViewTop) && (elemTop < docViewBottom));

            return isVisible;
        },
        triggerAnimations: function(){
            var that = this;
            var viewportWidth = $(window).width();

            if ( viewportWidth >= 768) {
                $('[data-animation]').each(function() {
                    if (that.isElementInViewport(this) === true) {
                        $(this).addClass($(this).data('animation'));
                    }
                });
            }
            else {
                $('[data-animation]').each(function() {
                    $(this).addClass($(this).data('animation'));
                });
            }
        },
        // triggerOnLoadAnimations: function(){
        //     $('[data-animation-on-load]').each(function() {
        //         $(this).addClass($(this).data('animation-animation-on-load'));
        //     });
        // }
    },
    comparisonTable: {
        init: function() {
            this.normalizeCellHeights();
        },
        normalizeCellHeights: function() {
            $('.table--comparison').each(function(){
                var $table = $(this);

                // mae all cells in a row the same height
                $table.find('[data-master-column] [data-cell-index]').each(function(){
                    var height = $(this).height();
                    var cellIndex = $(this).data('cell-index');

                    $table.find('[data-column] [data-cell-index=' + cellIndex + ']').height(height);
                });

                $table.removeClass('invisible');
            });
        }
    },
    modals: {
        init: function() {
            var that = this;

            $('body').on('click', '[data-close-modals]', function(){
                that.deactiveModals();
            });

            $('body').on('click', 'a[href^="@"]', function(event){
                event.preventDefault();

                var modalId = '#' + $(this).attr('href').replace(/@/g, "");

                that.activateModal($(modalId));
            });

            // handle vidyard lightbox
            $('body').on('click', 'a[href^="$"]', function(event){
                event.preventDefault();

                var vidyardUUID = $(this).attr('href').replace('$', '');

                launchLightbox(vidyardUUID);

                return false;
            })

            // add containers for Vidyard lightbox
            $('a[href^="$"]').each(function(){
                var html = '<div class="vidyard-player-embed" data-uuid="' + $(this).attr('href').replace('$', '') + '" data-v="4" data-type="lightbox"></div>';

                $('body').append(html);
            });

            // that.autoLoadModals();

            // khoros chat bot
            $('a[href^="*"]').on('click', function(event){
                event.preventDefault();

                $(this).trigger('on.click.event');
            });
        },
        // autoLoadModals: function() {
        //     var that = this;
        //
        //     $('.modal').each(function(){
        //         var $modal = $(this);
        //         var autoloadAttr = $modal.data('autoload');
        //         var modalCookieName = $modal.data('cookie-name');
        //
        //         // check for autoload attr
        //         var autoload = typeof autoloadAttr === typeof undefined ? false : true;
        //
        //         if (autoload) {
        //             //check for cookie
        //             var hasCookie = Cookies.get(modalCookieName);
        //
        //             if (hasCookie === undefined) {
        //                 setTimeout(function(){
        //                     that.activateModal($modal);
        //                 }, 2500);
        //             }
        //         }
        //     });
        // },
        activateModal: function($modal) {
            $modal.css({display: 'flex'});
            $modal.addClass('active');

            setTimeout(function(){
                $modal.addClass('active--phase2');
            }, 250);

            $('.outsideModals').addClass('blurred');
            $('body').css({
               height: '100vh',
               overflow: 'hidden'
            });

            // for Vidyard videos in modal
            var $vidyardContainer = $modal.find('[data-vidyard-embed]');

            if($vidyardContainer.length) {
                var $iframe = $vidyardContainer.find('iframe');

                $iframe.attr('src', $iframe.data('src'));

                // setTimeout(function(){
                //     var $vidyardVideo = $modal.find('.vidyard-player-container');
                //     var players = VidyardV4.api.getPlayersByUUID($vidyardVideo.attr('uuid'));
                //     players[0].play();
                // }, 1000)
            }
        },
        deactiveModals: function($modal) {
            $('[data-modal]').each(function(){
                var $modal = $(this);
                // var cookieName = $modal.data('cookie-name');

                $modal.css({display: 'none'});
                $modal.removeClass('active--phase2');
                $modal.removeClass('active');

                // if (cookieName.length > 0) {
                //     var $checkbox = $('#msg-' + cookieName);
                //
                //     if ($checkbox.prop("checked")) {
                //         Cookies.set(cookieName, '1', { expires: 365 });
                //     }
                //     else {
                //         Cookies.set(cookieName, '1');
                //     }
                // }

                // for Vidyard videos in modal
                var $vidyardContainer = $modal.find('[data-vidyard-embed]');

                if($vidyardContainer.length) {
                    var $iframe = $vidyardContainer.find('iframe');

                    $iframe.removeAttr('src');
                }
                // var $vidyardVideo = $modal.find('.vidyard-player-container');
                //
                // if($vidyardVideo.length) {
                //     var players = VidyardV4.api.getPlayersByUUID($vidyardVideo.attr('uuid'));
                //     players[0].pause();
                // }
            });

            $('.outsideModals').removeClass('blurred');
            $('body').css({
               height: 'auto',
               overflow: 'auto'
            });
        }
    },
    helloBar: {
        init: function(){
            var that = this;
            var $helloBar = $('.helloBar');
            var cookieName = $helloBar.data('cookie-name');
            var cookie = Cookies.get(cookieName);

            if (cookie === undefined && $helloBar.length) {
                $helloBar.find('[data-close]').on('click', function(){
                    that.dismissBar()
                });

                setTimeout(function(){
                    that.toggle();
                }, 3500);
            }
        },
        toggle: function(){
            var $helloBar = $('.helloBar');
            $helloBar.toggle();
        },
        dismissBar: function(){
            this.toggle();

            var $helloBar = $('.helloBar');
            var cookieName = $helloBar.data('cookie-name');

            Cookies.set(cookieName, '1');
        }
    },
    marketoForms: {
        init: function() {
            var formIds = [];

            $('[data-marketo-form]').each(function(){
                formIds.push($(this).data('marketo-form'));
            });

            var mktoFormConfig = {
                podId : "//pages.khoros.com",
                munchkinId : "104-HTZ-433",
                formIds : formIds
            };

            /* ---- NO NEED TO TOUCH ANYTHING BELOW THIS LINE! ---- */
            function mktoFormChain(config) {

                /* util */
                var arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

                /* const */
                var MKTOFORM_ID_ATTRNAME = "data-formId";

                /* fix inter-form label bug! */
                MktoForms2.whenRendered(function(form) {
                    var formEl = form.getFormElem()[0],
                        rando = "_" + new Date().getTime() + Math.random();

                arrayFrom(formEl.querySelectorAll("label[for]")).forEach(function(labelEl) {
                    var forEl = formEl.querySelector('[id="' + labelEl.htmlFor + '"]');
                    if (forEl) {
                        labelEl.htmlFor = forEl.id = forEl.id + rando;
                    }
                });
            });

            /* chain, ensuring only one #mktoForm_nnn exists at a time */
            arrayFrom(config.formIds).forEach(function(formId) {
                var loadForm = MktoForms2.loadForm.bind(MktoForms2,config.podId,config.munchkinId,formId),
                    formEls = arrayFrom(document.querySelectorAll("[" + MKTOFORM_ID_ATTRNAME + '="' + formId + '"]'));

                (function loadFormCb(formEls) {
                    var formEl = formEls.shift();
                    formEl.id = "mktoForm_" + formId;

                    loadForm(function(form) {
                        formEl.id = "";

                        // start autofill
                        // var $welcomeBackMessage = $('#welcomeBack_' + formId);
                        // var $form = $('[data-marketo-form="' + formId + '"]').first();
                        // var $formWrapper = $('#form-wrapper__form_' + formId);

                        // var hideMarketoFormFields = function($form){
                        //     $form.closest('.form-wrapper__form').find('.form-wrapper__heading').hide();
                        //     $form.find('.mktoFormRow').each(function() {
                        //         var $row = $(this);
                        //         if (!$(this).find('input[type=checkbox]').length) {
                        //             $row.hide();
                        //         }
                        //     });
                        // }

                        // var showMarketoFormFields = function($form) {
                        //     $form.closest('.form-wrapper__form').find('.form-wrapper__heading').show();
                        //     $form.find('.mktoFormRow').show();
                        // }

                        // reset cookies & form
                        // $('[data-reset-form]').on('click', function(event){
                        //     event.preventDefault();
                        //     $form.trigger("reset");
                        //     Cookies.remove('fn');
                        //     Cookies.remove('ln');
                        //     Cookies.remove('c');
                        //     Cookies.remove('e');
                        //     Cookies.remove('co');
                        //     Cookies.remove('jt');
                        //     $welcomeBackMessage.hide();
                        //     showMarketoFormFields($form);
                        // });

                        // setTimeout(function(){
                        //     // welcome back message
                        //     if (
                        //         (
                        //             window.location.href.includes('/resources/') ||
                        //             window.location.href.includes('/lp')
                        //         ) &&
                        //         Cookies.get('fn') != undefined &&
                        //         Cookies.get('fn').length &&
                        //         Cookies.get('jt') != undefined &&
                        //         Cookies.get('jt').length
                        //         )
                        //     {
                        //         var formType = $form.data('form-type');

                        //         if (formType != 'footer') {
                        //             $welcomeBackMessage.find('span').html(', ' + Cookies.get('fn') + '!');
                        //             $welcomeBackMessage.show();
                        //             hideMarketoFormFields($form);
                        //         }
                        //     }
                        //     else {
                        //         showMarketoFormFields($form);
                        //     }

                        //     // form autofill
                        //     $form.find("[id^=FirstName]").val(Cookies.get('fn'));
                        //     $form.find("[id^=LastName]").val(Cookies.get('ln'));
                        //     $form.find("[id^=Company]").val(Cookies.get('c'));
                        //     $form.find("[id^=Country]").val(Cookies.get('co'));
                        //     $form.find("[id^=Email]").val(Cookies.get('e'));
                        //     $form.find("[id^=Title]").val(Cookies.get('jt'));
                        // }, 2000);
                        // end autofill

                        if (formEls.length) {
                            loadFormCb(formEls);
                        }

                        var validateDomain = true;

                        // emails that will be rejected on validation
                        var invalidDomains = [
                            // "@1und1.",
                            "@aol.",
                            "@earthlink.",
                            "@email.",
                            "@freenet.",
                            "@gemail.",
                            "@gmail.",
                            "@gmx.",
                            "@googlemail.",
                            "@hotmail.",
                            "@icloud.",
                            "@laposte.net",
                            "@live.",
                            "@mail.",
                            "@me.",
                            "@msn.",
                            "@outlook.",
                            "@test.",
                            "@wanadoo.",
                            "@web.",
                            "@yahoo.",
                            "@ymail."
                        ];

                        // form validation for ESP address
                        form.onValidate(function(){
                            var email = form.vals().Email;

                            if(validateDomain && email){
                                if (isEmailGood(email)) {
                                    form.submitable(true);

                                }
                                else {
                                    form.submitable(false);

                                    var emailElem = $('[data-marketo-form=' + form.getId() + '] [name=Email]');

                                    form.showErrorMessage("Please provide a valid business email address.", emailElem);
                                }
                            }
                            else {
                                form.submitable(true);
                            }
                        });

                        // this checks the email domain based on the email domain array
                        function isEmailGood(email) {
                            for(var i=0; i < invalidDomains.length; i++) {
                                var domain = invalidDomains[i];
                                if (email.indexOf(domain) != -1) {
                                    return false;
                                }
                            }

                            return true;
                        }

                        // google data-layer push event
                        form.onSuccess( function( values, returnUrl ) {
                            var $form = form.getFormElem();

                            // check form type
                            var formType = $form.data('form-type');

                            if (formType != 'footer') {
                                // save values in cookies
                                Cookies.set('fn', values.FirstName);
                                Cookies.set('ln', values.LastName);
                                Cookies.set('c', values.Company);
                                Cookies.set('co', values.Country);
                                Cookies.set('e', values.Email);
                                Cookies.set('jt', values.Title);
                            }
                            else {
                                Cookies.set('e', values.Email);
                            }

                            dataLayer.push({
                                'event': 'MarketoFormSubmission',
                                'eventAction': 'Submit',
                                'eventCategory': $form.data('event-category'),
                                'eventValue': $form.data('event-value'),
                                'formId': form.getId(),
                                'formData': values,
                                'eventCallback': function(){
                                    if ($form.data('return-url')) {
                                        window.location.href = $form.data('return-url');
                                    }
                                    else {
                                        $form.find('button[type=submit]')
                                            .text('Thank you!')
                                            .attr('disabled','disabled');
                                        $form.find('input').attr('disabled','disabled');

                                        return false;
                                    }
                                }
                            });

                            return false;
                        });
                    });
                })(formEls);
            });
            }

            mktoFormChain(mktoFormConfig);
        }
    },
    trustRadiusTestimonials: {
        init: function(){
            var $TRReviews = $('#trustradius');

            if ($TRReviews.length > 0) {
                setTimeout(function(){
                    var html = '';

                    $TRReviews.find('.tr-review-summary').each(function(index){
                        html += '<li class="text-center">';
                        html += '    <p>' + $(this).find('p').text() + '</p>';
                        html += '    <div class="trustradius-tqw mt-1">' + $(this).find('.tr-rating').html() + '</div>';
                        html += '</li>';
                    });

                    $('[data-khoros-tr-reviews]').html(html);

                    //init slick slider
                    $('[data-khoros-tr-reviews]').slick({
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        responsive: [
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                              }
                            },
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                              }
                            },
                        ],
                        prevArrow: '<span class="slickArrow slickArrow-prev"></span>',
                        nextArrow: '<span class="slickArrow slickArrow-next"></span>',
                    });
                }, 3500);
            }
        },
    },
    carousel: {
        init: function(){
            if ($().slick) {
                //init slick slider
                $('[data-carousel]').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    responsive: [
                    ],
                    prevArrow: '<span class="slickArrow slickArrow-prev"></span>',
                    nextArrow: '<span class="slickArrow slickArrow-next"></span>',
                });
            }
        }
    },
    countUp: {
        isElementInViewport: function(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();

            var verticalOffset = 0;
            var elemTop = $(elem).offset().top - verticalOffset;
            var elemBottom = elemTop + $(elem).outerHeight();

            var isVisible = ((elemBottom > docViewTop) && (elemTop < docViewBottom));

            return isVisible;
        },
        animateCount: function($target){
            var count = 0;
            var finalValue = parseInt($target.data('count'), 10);
            var symbol = $target.data('count-symbol');
            var symbolString = typeof(symbol) === 'undefined' ? '' : symbol;
            var increment = parseInt((finalValue * 15 / 1250), 10);

            increment = increment === 0 ? 1 : increment;

            var countUp = setInterval(function(){
                count += increment;
                count = count > finalValue ? finalValue : count;

                var text =  count + symbolString;

                $target.html(text);

                if (count >= finalValue) {
                    clearInterval(countUp);
                }
            }, 15);
        },
        init: function(){
            var that = this;

            $('[data-count]').each(function(){
                if(that.isElementInViewport($(this)[0])) {
                    that.animateCount($(this));
                    $(this).removeAttr('data-count');

                    $(this).closest('section').addClass('k-animated');
                }
            });
        }
    },
    tableOfContent: {
        trackContent: function(){
            var that = this;

            $('.tableOfContentSection section').each(function(){
                if(that.isElementInViewport($(this))) {
                    that.activateContentLink($(this).attr('id'));
                }
            });
        },
        activateContentLink: function(id) {
            var $links = $('.tableOfContentSection aside a');

            $links.removeClass('active');

            $links.each(function(){
                if ($(this).attr('href') == '#' + id) {
                    $(this).addClass('active');
                }
            });
        },
        isElementInViewport: function(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height()/2 ;

            var verticalOffset = 0;
            var elemTop = $(elem).offset().top - verticalOffset;
            var elemBottom = elemTop + $(elem).outerHeight();

            var isVisible = ((elemBottom > docViewTop) && (elemTop < docViewBottom));

            return isVisible;
        },
    },
    lazyloadResources: {
        init: function() {
            var lazyLoadInstance = new LazyLoad({
              // Your custom settings go here
            });
        }
    },
    accordion: {
        init: function() {
            $('[data-accordion-row]').on('click', 'h2', function(){
                var $row = $(this).closest('[data-accordion-row]');

                $row.toggleClass('active');
                $row.find('.richText').slideToggle();
            });
        }
    },
    blogContent: {
        init: function() {
            // dynamically add support for image zoom functionality
            $('[data-blog-content-controls]').on('click', '[data-control]', function(){
               $('body').toggleClass('content--expanded');
            });

            //dynamically add responsive iframe support for youtube embedded content
            $('.blogPost .editorialSection iframe').each(function(){
                var $iframe = $(this);
                var src = $iframe.attr('src');

                if ($iframe.parents('responsiveContainer').length == 0 && src.includes('youtube.com')) {
                    $iframe.wrap('<div class="responsiveContainer"></div>');
                }
            });
        }
    },
    vidyardVideosCaptions: {
        init: function(){
            var language = $('html').attr('lang');
            var $videoImg = $('[data-uuid]').first();
            var videoUUID = $videoImg.data('uuid');

            var players = VidyardV4.api.getPlayersByUUID(videoUUID);

            if (players|length > 0) {
                var player = players[0];

                if (language == 'fr') {
                    player.enableCaption('Français', 'fr');
                }
                else if (language == 'de') {
                    player.enableCaption('Deutsch', 'de');
                }
            }
        }
    },
    // imageZoom: {
    //     init: function() {
    //         $('[data-blog-content] .richText img').each(function(){
    //             var $image = $(this);
    //             var src = $(this).attr('src');
    //             var $outerLink = $(this).closest('a');

    //             if (
    //                 $outerLink.length == 0 ||
    //                 ($outerLink.length > 0 && !$outerLink.attr('href').includes('khoros.com'))
    //                )
    //             {
    //                 $image.wrap('<a href="#" data-featherlight="' + src + '"/>');
    //             }
    //         })
    //     }
    // },
    languageSites: {
        init: function() {
            var searchParams = new URLSearchParams(window.location.search);
            var forcedCountryCode = searchParams.get('cc');

            //get region prompt cookie
            var cookie = Cookies.get('khoros-region-prompt');

            if (cookie === undefined) {
                var countryCode = '';

                if (forcedCountryCode) {
                    countryCode = forcedCountryCode;
                }
                else {
                    var $ip = $('input#ip');
                    countryCode = $.get( "/api/geo.php", {ip:  $ip.val()});

                    $ip.remove();
                }

                if (countryCode == 'AU' || countryCode == 'NZ') {
                    this.showSitePrompt(countryCode);
                }
            }
        },
        showSitePrompt: function(countryCode) {
            var siteUrl = '';
            var $sitePrompt = $('#sitePrompt');

            $sitePrompt.find('[data-region="' + countryCode + '"]').show();
            $sitePrompt.addClass('active');

            Cookies.set('khoros-region-prompt', countryCode);
        }
    },
    funnelWidget: {
        init: function() {
            var that = this;

            that.expandWidgetHeight();
            that.wireUpShowModalEvents();
            that.wireUpMobileEvents();

            $('[data-hover]').on('mouseenter', function(){
                var $target = $($(this).data('hover'));

                $('[data-panel]').removeClass('active');
                $target.addClass('active');

                $('[data-hover]').removeClass('active');
                $(this).addClass('active');
            });

            $('[data-funnel-toggle]').on('click', function(){
                var $toggle = $(this);
                var $target = $($(this).data('funnel-toggle'));
                var $section = $target.closest('.funnelSection');

                $section.removeClass('bg-navy bg-white');
                $section.addClass($toggle.data('funnel-bg-color'));

                $('[data-funnel-slides]').removeClass('active');
                $target.addClass('active');

                $('[data-funnel-toggle]').removeClass('active');
                $(this).addClass('active');

                that.expandWidgetHeight();
            });

            $('[data-hover]').on('mouseleave', function(){
                var $target = $($(this).data('hover'));
                $('[data-panel]').removeClass('active');
                $('#slide-default').addClass('active');
                $('#slide-default-2').addClass('active');
            });
        },
        expandWidgetHeight: function() {
            //normalized panel heights
            $('[data-funnel-panels]').each(function(){
                var $parent = $(this);
                var height = 0;

                $parent.find('[data-panel]').each(function(){
                    var innerHeight = $(this).innerHeight();
                   if (height < innerHeight) {
                       height = innerHeight + 80;
                   }
                });

                $parent.height(height);
            });
        },
        wireUpShowModalEvents: function() {
            $('[data-funnel-modal]').removeClass('active');

            $('[data-open-funnel-modal]').on('click', function(){
                $('#' + $(this).data('open-funnel-modal')).addClass('active');
            });

            $('[data-funnel-modal-close]').on('click', function(){
                $('[data-funnel-modal]').removeClass('active');
            })
        },
        wireUpMobileEvents: function() {
            $('[data-funnel-details-toggle]').on('click', function(){
                var $toggle = $(this);
                var $target = $('[data-funnel-details="' + $toggle.data('funnel-details-toggle')+ '"]');

                if ($target.length) {
                    $target.slideToggle();
                    $toggle.slideToggle();
                }
            });

            $('[data-funnel-details]').on('click', function(){
                var $toggle = $(this);
                var $target = $('[data-funnel-details-toggle="' + $toggle.data('funnel-details')+ '"]');

                if ($target.length) {
                    $target.slideToggle();
                    $toggle.slideToggle();
                }
            });
        }
    },
    integrations: {
        init: function() {
            if (Cookies.get('e') != undefined) {
                var e = Cookies.get('e');

                dataLayer.push({
                    'email': e
                });
            }
        }
    }
}

$(function(){
    KHOROS.lazyloadResources.init();
    KHOROS.sliders.init();
    KHOROS.elementToggles.init();
    KHOROS.mobileMenu.init();
    KHOROS.modals.init();
    KHOROS.accordion.init();
    KHOROS.blogContent.init();
    KHOROS.marketoForms.init();
    KHOROS.carousel.init();
    KHOROS.funnelWidget.init();

    KHOROS.helloBar.init();
    KHOROS.trustRadiusTestimonials.init();

    if ($(window).width() >= 768) {
        KHOROS.sliders.normalizeSlideHeights();
    }

    var resizeTimer;
    var scrollTimer;

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            // run only on wider viewports
            if ($(window).width() >= 768) {
                KHOROS.comparisonTable.normalizeCellHeights();
                KHOROS.sliders.normalizeSlideHeights();
            }
            else {
                KHOROS.sliders.resetSlideHeights();
            }
        }, 250);
    });

    $(window).on('scroll', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            var viewportWidth = $(window).width();

            if ( viewportWidth >= 768) {
                KHOROS.animations.triggerAnimations();
            }

            KHOROS.countUp.init();
            KHOROS.tableOfContent.trackContent();
        }, 50);
    });

    KHOROS.animations.triggerAnimations();

    setTimeout(function(){
        KHOROS.vidyardVideosCaptions.init();
        // KHOROS.imageZoom.init();
    }, 5000);

    KHOROS.integrations.init();
});
